export default __webpack_public_path__ + "static/media/h2.a620cfe3.jpg";